import { get } from 'lodash'
import moment from 'moment'
import { required, email } from 'utils/validation'
import { CONSENT_DELIVERY_TYPES } from 'constants/enums'

export default function(values) {
  const olderThan18 =
    (get(values, 'participant.birthDate') &&
      moment().diff(values.participant.birthDate, 'years') >= 18) ||
    false
  let isParentEmailRequired = email(
    get(values, 'participantRegistration.parentEmail')
  )

  if (!olderThan18) {
    if (
      CONSENT_DELIVERY_TYPES.electronically.id ===
      get(values, 'consentDeliveryType.value')
    ) {
      isParentEmailRequired =
        required(get(values, 'participantRegistration.parentEmail')) ||
        email(get(values, 'participantRegistration.parentEmail'))
    }
  }

  const errors = {
    awardLeader: {
      id: required(get(values, 'awardLeader.id'))
    },
    startDate: required(get(values, 'startDate')),
    consentDeliveryType: {
      value: !olderThan18
        ? required(get(values, 'consentDeliveryType.value'))
        : undefined
    },
    participantRegistration: {
      parentFirstName: !olderThan18
        ? required(get(values, 'participantRegistration.parentFirstName'))
        : undefined,
      parentLastName: !olderThan18
        ? required(get(values, 'participantRegistration.parentLastName'))
        : undefined,
      parentEmail: isParentEmailRequired,
      parentPhone: !olderThan18
        ? required(get(values, 'participantRegistration.parentPhone'))
        : undefined
    }
  }

  if (get(values, 'secondaryPhone') && get(values, 'secondaryPhone') !== '+') {
    errors.secondaryPhoneType = {
      value: required(get(values, 'secondaryPhoneType.value'))
    }
  }

  return errors
}
